import api from '@/utils/api';
import { accountingSettingGroup } from '@/assets/commonData/options';

const state = {
    accoutingSettings: [],
};

const getters = {
    accountingSettings: (state) => state.accoutingSettings,
    settingsForSelect: (state) => {
        const options = [];

        Object.keys(state.accoutingSettings).forEach((key, index) => {
            const children = [];
            state.accoutingSettings[key].forEach((item) => {
                children.push({
                    sno: item.sno,
                    label: `${item.accno} - ${item.accnam}`,
                    value: item.accno,
                    accno: item.accno,
                    accnam: item.accnam,
                    leaf: true,
                });
            });

            options.push({
                key,
                label: `${index + 1} - ${accountingSettingGroup.find((x) => x.key === key).value}`,
                value: key,
                children,
            });
        });

        return options;
    },
};

const actions = {
    updateAccountingSettings({ commit }) {
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetAccountingSettings', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_AccountingSettings', resp.data);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    update_AccountingSettings(state, settings) {
        state.accoutingSettings = settings;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
